<template>
  <div>
    <vuestic-modal ref="presenca" :cancelClass="'none'" :okClass="'none'">
      <div slot="title">Presença Aluno</div>
      <table>
        <thead>
          <tr>
            <th>FOTO</th>
            <th>TIPO</th>
            <th>HORÁRIO</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="presenca in data_presenca">
            <td>
              <img width="100" :src="'data:image/jpg;base64, ' + presenca.foto" alt="Foto">
            </td>
            <td v-show="presenca.tipo == 0">Entrada</td>
            <td v-show="presenca.tipo == 1">Saída</td>
            <td v-show="presenca.tipo == 2">Intervalo</td>
            <td v-show="presenca.tipo.length > 1">{{ presenca.tipo }}</td>
            <td>{{ presenca.created_at }}</td>
          </tr>
        </tbody>
      </table>
      <br><br>
      <div class="col-md-12">
        <header>
          <h5>FOTOS AULAS TEÓRICAS</h5>
          <hr>
        </header>
        <div class="row">
          <div class="col-md-4" v-for="foto in data_imagens_teoricas">
            <img width="100" :src="'data:image/jpg;base64, ' + foto" alt="Foto">
          </div>
        </div>
      </div>
    </vuestic-modal>
    <vuestic-modal ref="modal" :cancelClass="'none'" :okClass="'none'">
      <div slot="title">{{ modal.conteudo.nome }}</div>
        <table>
          <thead>
            <tr>
              <th>Entrada</th>
              <th>Intervalo</th>
              <th>Saída</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <input type="time" v-model="modal.conteudo.entrada" />
              </td>
              <td>
                <span v-show="modal.conteudo.entidade === 'ALUNO'"
                  ><input type="time" v-model="modal.conteudo.intervalo"
                /></span>
                <span v-show="modal.conteudo.entidade === 'INSTRUTOR'"
                  ><input type="time" disabled
                /></span>
              </td>
              <td>
                <input type="time" v-model="modal.conteudo.saida" />
              </td>
            </tr>
            <tr>
              <td colspan="3">
                <button
                  type="button"
                  @click="marcarPresenca()"
                  class="btn btn-micro btn-primary"
                >
                  Confirmar Presença
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      <div v-show="modal.load"></div>
    </vuestic-modal>
    <!--Legenda com barra de pesquisa-->
    <div class="row">
      <div class="col-md-6 text-left">
        <span class="circle badge-danger"></span> AUSENTE &nbsp;
        <span class="circle badge-warning"></span> PRESENTE
        <span> (entrada/saida) </span> &nbsp;
        <span class="circle badge-success"></span> PRESENTE &nbsp;
      </div>
      <div class="col-md-3">
        <i
          alt="Download PDF"
          @click="openModal('/turmas/presencas/arquivo', 'pdf', 'Presenças')"
          id="downloadButton"
          class="fa fa-file-pdf-o"
        >
          <span class="tooltiptext">Download PDF</span> </i
        >&nbsp;&nbsp;
        <!-- <i @click="openModal('aulas/teoricas', 'xlsx')" id="downloadButton" class="fa fa-file-excel-o">
              <span class="tooltiptext">Download XLSX</span>
            </i>&nbsp;&nbsp;
            <i @click="openModal('aulas/teoricas', 'txt')" id="downloadButton" class="fa fa-file-text-o">
              <span class="tooltiptext  ">Download TXT</span>
            </i> -->
      </div>
      <div class="col-md-3">
        <fieldset>
          <div class="form-group with-icon-left">
            <div class="input-group">
              <input
                @input="debounceInput"
                id="search"
                autocomplete="off"
                required
              />
              <label class="control-label" for="search">Procurar...</label
              ><i class="bar"></i>
              <i class="fa icon-left input-icon fa-search"></i>
            </div>
          </div>
        </fieldset>
      </div>
    </div>
    <!--Legenda com barra de pesquisa-->

    <!--Tabela-->
    <div class="row">
      <div class="col-md-12">
        <table class="table table-responsive-sm" v-show="!presenca.show">
          <thead>
            <tr>
              <th v-for="th in tableOptions.thead" scope="col" :key="th.id">
                {{ th }}
              </th>
              <th v-if="user === 'admin' || user === 'cizaias'" scope="col">Adicionar Presença</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="table.load">
              <td colspan="7" class="text-center">
                <div
                  class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center"
                >
                  <div
                    class="btn-toolbar d-inline-flex"
                    role="toolbar"
                    aria-label="Toolbar with button groups"
                  >
                    <component
                      :animation-duration="1000"
                      :is="'SpringSpinner'"
                      :color="'#4AE387'"
                      :size="80"
                    >
                    </component>
                  </div>
                </div>
              </td>
            </tr>
            <template v-show="!table.load" v-for="dados in lista">
              <tr :key="dados.cpf + 'entidade'">
                <td>{{ dados.nome }}</td>
                <td>{{ dados.cpf }}</td>
                <td>{{ dados.entidade }}</td>
                <td>
                  <span class="circle badge-danger" v-show="dados.presenca == 0" title="Ausente"></span>
                  <span class="circle badge-warning" v-show="dados.presenca == 1" title="Presente"></span>
                  <span class="circle badge-success" v-show="dados.presenca == 2" title="Presente"></span>
                </td>
                <td v-if="dados.status">{{ dados.status }}</td>
                <td v-else-if="!dados.status && dados.entidade == 'ALUNO'">ALUNO REPOSIÇÃO</td>
                <td v-else>INSTRUTOR</td>
                <td v-if="dados.presenca == 1 || dados.presenca == 2">
                  <button title="Visualizar Foto" class="btn btn-primary btn-with-icon rounded-icon btn-micro" @click="viewPresenca(dados)">
                    <span aria-hidden="true" class="fa fa-picture-o" style="font-size: 20px; padding-left: 3px"></span>
                  </button>
                </td>
                <td v-else>AUSENTE</td>
                <td> {{ dados.dispositivo }} </td>
                <td v-if="user === 'admin' && idRole != 3">
                  <button v-if="dados.presenca !== 2" title="Adicionar Presença" class="btn btn-primary btn-with-icon rounded-icon btn-micro" @click="openModalPresenca(dados)">
                    <span aria-hidden="true" class="fa fa-plus" style="font-size: 20px; padding-left: 3px"></span>
                  </button>
                  <button v-show="dados.presenca === 2" class="btn btn-primary btn-with-icon rounded-icon btn-micro disabled">
                    <span aria-hidden="true" class="fa fa-plus" style="font-size: 20px; padding-left: 3px"></span>
                  </button>
                </td>
                <!--
                <td>
                  <button title="Ver informações do aluno" class="btn btn-primary btn-with-icon rounded-icon btn-micro" @click="loadPresenca(dados.id_aluno, dados.id_instrutor, dados.nome)"><span aria-hidden="true" class="fa fa-plus" style="font-size: 16px;"></span>
                  </button>
                </td>
                -->
              </tr>
            </template>
            <tr v-show="lista.length === 0 && !table.load">
              <td colspan="9" class="text-center">
                Nenhum registro encontrado.
              </td>
            </tr>
          </tbody>
        </table>

      </div>
    </div>
    <!--Tabela-->
  </div>
</template>

<script>
import TurmasController from "./TurmasController";
import * as spinners from "epic-spinners";
import DateIconGroup from "@/vuestic-theme/vuestic-components/vuestic-input/DateIconGroup";
import InputCheckboxGroup from "@/vuestic-theme/vuestic-components/vuestic-input/InputCheckboxGroup";
import urlApi from "../../router/urlApi";
import utils from "../../services/utils";
import _ from "lodash";

window._ = require("lodash");

export default {
  name: "TableAulasTurma",
  props: ["idTurma", "virtual", "data_inicio", "idRole"],
  components: {
    ...spinners,
    DateIconGroup,
  },
  data() {
    return {
      user: '',
      presenca: {
        id_aluno: '',
        id_instrutor: '',
        nome: '',
        id_turma: '',
        entrada: '',
        // saida: '',
        tipo: '',
        foto: '',
        show: false,
      },
      modal: {
        show: false,
        load: false,
        conteudo: {
          turma_id: "",
          id: "",
          nome: "",
          entidade: "",
          entrada: "",
          intervalo: "",
          saida: "",
        },
      },
      url: urlApi + "/aulas/teoricas/presenca",
      tableOptions: {
        thead: [
          "Nome",
          "CPF",
          "Entidade",
          "Presença",
          "Status",
          "Foto Presença",
          "Dispositivo"
        ],
      },
      search: "",
      table: {
        currentPage: "",
        data: "",
        firstPageUrl: "",
        from: "",
        lastPage: "",
        lastPageUrl: "",
        nextPageUrl: "",
        path: "",
        perPage: "",
        prevPageUrl: "",
        to: "",
        total: "",
        pages: [],
        load: true,
      },
      utils: utils,
      fileName: "",
      fileExt: "",
      fotoSelecionada: null,
      lista: [],
      data_presenca: [],
      data_imagens_teoricas: [],
    };
  },
  mounted() {
    this.loadData();
    let email = localStorage.email.split("@")
    this.user = email[0];
  },
  methods: {
    callbackDataPaginate(response) {
      //console.log(response);
      let responseData = response.data;
      this.table.currentPage = responseData.current_page;
      this.table.data = responseData.data;
      this.table.firstPageUrl = responseData.first_page_url;
      this.table.from = responseData.from;
      this.table.lastPage = responseData.last_page;
      this.table.lastPageUrl = responseData.last_page_url;
      this.table.nextPageUrl = responseData.next_page_url;
      this.table.path = responseData.path;
      this.table.perPage = responseData.per_page;
      this.table.prevPageUrl = responseData.prev_page_url;
      this.table.to = responseData.to;
      this.table.total = responseData.total;

      this.table.pages = [];
      for (let i = 1; i <= responseData.last_page; i++) {
        this.table.pages.push(i);
      }

      var i;
      for (i = 0; i < this.table.data.length; i++) {
        if (this.table.data[i].presenca >= 2) {
          this.table.data[i].presenca = "Presente";
        } else if (this.table.data[i].presenca == 1) {
          this.table.data[i].presenca = "Semi-presente";
        } else {
          this.table.data[i].presenca = "Ausente";
        }
      }

      this.items = this.table.data;

      this.table.load = false;
    },
    nextPage() {
      this.table.load = true;
      this.$http
        .get(this.table.nextPageUrl + "&search=" + this.search)
        .then(this.callbackDataPaginate);
    },
    previousPage() {
      this.table.load = true;
      this.$http
        .get(this.table.prevPageUrl + "&search=" + this.search)
        .then(this.callbackDataPaginate);
    },
    loadData() {
      this.table.load = true;
      this.$http
        .get(this.url + "/" + this.idTurma + "?search=" + this.search)
        .then((response) => {
          this.lista = response.data;
          this.table.load = false;
        });
    },
    pagePaginate(page) {
      this.table.load = true;
      this.$http
        .get(
          this.url +
            "/" +
            this.idTurma +
            "?search=" +
            this.search +
            "&page=" +
            page
        )
        .then(this.callbackDataPaginate);
    },
    openModal(entity, ext, title) {
      this.fileName = entity;
      this.fileExt = ext;

      if (ext == "pdf") {
        utils.generatePDFTurmas(this.idTurma, entity, ext, title);
      }
    },
    openModalPresenca(aluno) {
      this.$refs.modal.open();
      this.modal.conteudo.turma_id = this.idTurma;
      if (aluno.id_aluno) {
        this.modal.conteudo.id = aluno.id_aluno;
      } else {
        this.modal.conteudo.id = aluno.id_instrutor;
      }
      this.modal.conteudo.nome = aluno.nome;
      this.modal.conteudo.entidade = aluno.entidade;
      this.modal.show = true;
    },
    addPresenca() {
      this.$http
        .post(urlApi + "/turmas/adicionar/presenca", {
          aula: this.modal.conteudo,
        })
        .then(function (response) {
          //console.log(response);
          this.modal.load = true;
          this.$toasted.show(response.data.mensagem, {
            position: "top-right",
          });
          if(response.data.mensagem === 'Presença efetuada com sucesso!')
          this.$refs.modal.close();
        })
        .then(this.loadData())
        .catch(function (error) {
          console.log(error);
          PresencaController.launchToast("fa-times", error.data.dados);
        });
    },

    posicao(index) {
      let distancia = index - this.table.currentPage;
      //console.log(distancia);
      if (distancia > -3 && distancia < 1) {
        return true;
      }
      return false;
    },

    ver(cpf) {
      this.fotoSelecionada = null;
      this.$http.get(urlApi + "/turmas/foto/entidade/" + this.idTurma + "/" + cpf).then((res) => {
        this.fotoSelecionada = res.body;
      });

      this.mostrar(cpf);
    },

    mostrar(cpf) {
      var el = document.getElementById(cpf);
      var todos = document.getElementsByClassName("tr");

      if (el.style.display == "block") {
        el.style.display = "none";
      } else {
        for (let index = 0; index < todos.length; index++) {
          todos[index].style.display = "none";
        }

        el.style.display = "block";
        //console.log(todos);
      }
    },

    getfile() {
      var idTurma = 3;
      var date;

      if (this.fileExt == "pdf") {
        utils.generatePDF(this.fileName, idTurma, date);
      } else {
        utils.generateTXTorXLSX(this.fileName, this.fileExt, idTurma, date);
      }
    },

    viewPresenca(dados) {
      let self = this;
      const id_entidade = dados.id_aluno !== undefined ? dados.id_aluno : dados.id_instrutor;
      const entidade = dados.entidade;
      const id_turma = this.idTurma;
      const virtual = this.virtual;
      const url = `${urlApi}/alunos/detalhes-presencas/${id_entidade}/${id_turma}/${entidade}/${virtual}`;

      this.$http.get(url).then((res) => {
        const dataPresenca = res.data.dados.presencas;
        const fotosTeoricas = res.data.dados.fotos_teoricas;

        this.data_presenca = [];
        this.data_imagens_teoricas = [];

        console.log(res.data.dados);

        dataPresenca.forEach((response) => {
          this.data_presenca.push(response);
        });

        fotosTeoricas.forEach((response) => {
          this.data_imagens_teoricas.push(response.foto);
        });

        //self.$refs.modal.close();
        this.$refs.presenca.open();
      });
    },

    debounceInput: _.debounce(function (e) {
      this.search = e.target.value;
      this.loadData();
    }, 1000),

    marcarPresenca() {
      if (this.modal.conteudo.entidade === "INSTRUTOR") {
        if (
          this.modal.conteudo.entrada == "" ||
          this.modal.conteudo.saida === ""
        ) {
          this.$toasted.show("Necessário informar todos os campos!", {
            position: "top-right",
          });
        } else {
          this.addPresenca();
        }
      } else if (this.modal.conteudo.entidade === "ALUNO") {
        if (
          this.modal.conteudo.entrada === "" ||
          this.modal.conteudo.saida === ""
        ) {
          this.$toasted.show("Necessário informar pelo menos os campos de entrada e saída", {
            position: "top-right",
          });
        } else {
          this.addPresenca();
        }
      }
    },
  },
};
</script>

<style type="text/css" scoped>
.tb-opcoes {
  display: block;
  position: absolute;
  right: 20px;
  margin-top: -8px;
}

.tb-linha:hover .tb-opcoes {
  display: block;
}

@media (max-width: 1200px) {
  .tb-opcoes {
    display: block;
  }
}

.circle {
  width: 0.75rem;
  height: 0.75rem;
  border-radius: 50%;
  display: inline-block;
}

.clicar {
  cursor: pointer;
}
</style>
